import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import EventIcon from "@mui/icons-material/Event";
import PaymentIcon from "@mui/icons-material/Payment";
import PetsIcon from "@mui/icons-material/Pets";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import SecurityIcon from "@mui/icons-material/Security";

interface Category {
  id: string;
  name: string;
  description: string;
  icon: React.ReactNode;
}

const CATEGORIES: Category[] = [
  {
    id: "getting-started",
    name: "Getting Started",
    description: "New to HappyPaws? Start here",
    icon: <RocketLaunchIcon sx={{ fontSize: 64, color: "#178B8E" }} />,
  },
  {
    id: "bookings",
    name: "Bookings",
    description: "Find sitters and manage bookings",
    icon: <EventIcon sx={{ fontSize: 64, color: "#178B8E" }} />,
  },
  {
    id: "payments",
    name: "Payments",
    description: "Billing, refunds, and receipts",
    icon: <PaymentIcon sx={{ fontSize: 64, color: "#178B8E" }} />,
  },
  {
    id: "my-pets",
    name: "My Pets",
    description: "Add and manage pet profiles",
    icon: <PetsIcon sx={{ fontSize: 64, color: "#178B8E" }} />,
  },
  {
    id: "messaging",
    name: "Messaging",
    description: "Communicate with sitters",
    icon: <ChatBubbleIcon sx={{ fontSize: 64, color: "#178B8E" }} />,
  },
  {
    id: "account-safety",
    name: "Account & Safety",
    description: "Settings, privacy, and security",
    icon: <SecurityIcon sx={{ fontSize: 64, color: "#178B8E" }} />,
  },
];

interface CategoriesGridProps {
  onCategoryClick: (categoryId: string) => void;
}

const CategoriesGrid: React.FC<CategoriesGridProps> = ({ onCategoryClick }) => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={600} mb={3}>
        Browse by Category
      </Typography>
      <Grid container spacing={3}>
        {CATEGORIES.map((category) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={category.id}>
            <Paper
              onClick={() => onCategoryClick(category.id)}
              sx={{
                p: 3,
                borderRadius: 2,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                cursor: "pointer",
                transition: "all 0.25s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 8,
                },
              }}
            >
              <Box mb={1.5}>{category.icon}</Box>
              <Typography variant="h6" fontWeight={600} mb={0.5}>
                {category.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {category.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CategoriesGrid;
